export const defaultOptions = {
    url: 'https://api.geocode.earth/v1'
};
